import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Panel } from 'react-bootstrap';
import { ButtonType, Button } from '@checkmarx/cx-ui';
import styles from '../style.scss';

@inject('translationsStore', 'twoFAStore') @observer

export default class ResetAuthKey extends Component {

    componentWillMount() {
        this.props.twoFAStore.changeStepInProgress(false);
    }

    handleSubmitForm = (e) => {
        e.preventDefault();
        this.props.twoFAStore.changeStepInProgress(true);
        this.props.twoFAStore.resetAuthenticatorKey().then((response) => {
            if (response === true) {
                this.props.twoFAStore.authenticatorKetResetted = true;
                this.props.twoFAStore.authenticatorKeyMessage =  this.props.translationsStore.translate('RESET_AUTHKEY_CONFIG');
                this.props.twoFAStore.changeStep(this.props.twoFAStore.twoFactorSteps.setupauthapp);
            }
            this.props.twoFAStore.changeStepInProgress(false);
        });
    };

    render() {
        const { twoFactorSteps, stepInProgress} = this.props.twoFAStore;

        return (<div>
            <form onSubmit={this.handleSubmitForm}>
                <div className='tab-dialog subTitle'>
                    {this.props.translationsStore.translate('RESET_AUTHENTICATOR_TITLE')}
                </div>
                <Panel className='infoPanel'>
                    <div className='boldtext'>{this.props.translationsStore.translate('RESET_AUTH_MESSAGE1')}</div>
                    <div style={{ paddingTop: '10px' }}>{this.props.translationsStore.translate('RESET_AUTH_MESSAGE2')}</div>
                </Panel>
                <div className='buttonDiv'>
                    <Button
                        type="submit"
                        id="btnResetAuthenticatorKey"
                        text={this.props.translationsStore.translate('RESET_AUTHENTICATOR_TITLE')}
                        inProgress={stepInProgress}
                    />
                    <Button
                        text={this.props.translationsStore.translate('BACK')}
                        onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.authoptions)}
                    />
                </div>
            </form>
        </div>)
    }
}





// WEBPACK FOOTER //
// ./src/components/account/twoFA/resetAuthKey/index.jsx